// extracted by mini-css-extract-plugin
module.exports = {"paperRoot":"FormDialog_paperRoot__2hRuD","dialogContent":"FormDialog_dialogContent__3XTqp","formWrapper":"FormDialog_formWrapper__2AOwR","error":"FormDialog_error__2cwXr"};